﻿export namespace DataAuditLogPermissionKeys {
    export const DataAuditLog = "Administration:DataAuditLog";
}